import React, { useState } from 'react';
import './Header2.css';
import { useNavigate, Link } from 'react-router-dom';

const Header2 = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    navigate(`/Showtimes${query.trim() ? `?q=${encodeURIComponent(query.trim())}` : ''}`);
  };

  return (
    <header className="amc-header1">
      <div className="amc-header-content">
        <div className="linksnav">
          <ul className="amc-nav-link">
            <li>
              <Link to="/Login">StarView X Membership</Link>
            </li>
          </ul>
        </div>

        <form className="search-form" onSubmit={handleSearch}>
          <input
            type="text"
            id="searchInput"
            placeholder="Search movies..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <button type="submit" aria-label="Search">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="7" cy="7" r="5.5" stroke="currentColor" strokeWidth="1.5" />
              <path d="M11.5 11.5L14.5 14.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </button>
        </form>

        <div className="linksnav">
          <ul className="amc-nav-link2">
            <li><Link to="/Merchandise">Merchandise</Link></li>
            <li><Link to="/GiftCards">Gift Cards</Link></li>
            <li><Link to="/Offers">Offers & Discounts</Link></li>
            <li><Link to="/CountryExclusive">Country Exclusive</Link></li>
            <li><Link to="/drive">Drive With Us</Link></li>
            <li><Link to="/partner/restaurant/apply">Partner Your Restaurant</Link></li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header2;
